<template>
  <section>
    <table class="voucher-table combine-type">
      <caption>
        더블 이용권 표
      </caption>
      <colgroup>
        <col style="width: 230px" />
        <col />
        <col />
        <col />
        <col />
      </colgroup>
      <thead>
        <tr>
          <th>
            <span class="a11y-hidden">이용권 상품 목록 (더블 이용권)</span>
          </th>
          <th
            v-for="(voucher, thIndex) in voucherList"
            :key="`voucher_head__${thIndex}`"
            scope="col"
          >
            <VoucherTableHead
              :key="`${voucher.quality_name}__${thIndex}`"
              :voucher="voucher"
              :selected-product="selectedProduct"
              @on-click-product="onClickProduct"
            />
          </th>
        </tr>
      </thead>
      <tbody>
        <VoucherTableRow
          v-for="(voucher, trIndex) in voucherTableList(
            voucherList,
            bodyDescriptionList,
          )"
          :key="`tr__${trIndex}__${voucher.title}`"
          :voucher="voucher"
        />
      </tbody>
    </table>
    <div class="partner-benefit-box">
      <strong class="title">더블 이용권 공통혜택</strong>
      <div class="box">
        <dl
          v-for="benefit in VOUCHER_INTEGRATED_BENEFITS"
          :key="benefit?.title"
        >
          <dt>{{ benefit?.title }}</dt>
          <dd v-for="(item, index) in benefit?.benefits" :key="index">
            {{ item }}
          </dd>
        </dl>
      </div>
    </div>
  </section>
</template>
<script setup>
  import { defineProps } from 'vue'
  import { useVoucherTable } from '@/common/use/useVoucherTable'
  import VoucherTableHead from '@/components/voucher/VoucherTableHead.vue'
  import VoucherTableRow from '@/components/voucher/VoucherTableRow.vue'
  import { VOUCHER_INTEGRATED_BENEFITS } from '@/components/voucher/partner/const'

  const {
    selectedProduct,
    refinePurchasePayload,
    getVoucherTableRow,
    voucherTableList,
  } = useVoucherTable()

  const props = defineProps({
    voucherPurchaseFn: {
      type: Function,
      default: () => {},
    },
    voucherList: {
      type: Array,
      default: () => [],
    },
    bodyDescriptionList: {
      type: Array,
      default: () => [],
    },
  })

  const onClickProduct = (voucher, product) => {
    const payload = refinePurchasePayload(voucher, product)

    return props.voucherPurchaseFn(payload)
  }

  const init = () =>
    getVoucherTableRow(props.voucherList, props.bodyDescriptionList)

  init()
</script>
<style lang="scss" src="@/assets/scss/category/ticket.scss"></style>
<style lang="scss" scoped>
  .partner {
    &-benefit-box {
      margin-top: 20px;
      padding: 36px 40px;
      border: 1px solid #252525;
      border-radius: 8px;
      .title {
        font-size: 20px;
        line-height: 28px;
        font-weight: normal;
      }
      .box {
        margin-top: 20px;
        display: flex;
        > dl {
          width: 100%;
          dt {
            font-size: 14px;
            line-height: 20px;
            font-weight: bold;
          }
          dd {
            position: relative;
            margin-top: 8px;
            padding-left: 28px;
            font-size: 14px;
            line-height: 20px;
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 20px;
              height: 20px;
              background: url(~@/assets/images/common/ico-check-gray.png)
                no-repeat center / cover;
            }
          }
        }
      }
    }
  }
</style>
